import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GSC_INDIVIDUAL_RANKING_KEY } from '../../constants/queryKeys';
import { GET_GSC_INDIVIDUAL_RANKING_URL } from '../../constants/apiUrls';
import { PostRankingDetailsResponse } from './usePostGroupRankingDetails';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GetIndividualRankingDetailsResponse extends PostRankingDetailsResponse {
  orderOfMeritPosition: number;
  orderOfMeritMaximum: number;
  subjectForecastGrade: string;
  subjectForecastGradePrelim?: string;
  psleMarks?: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetIndividualRankingDetailsResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetIndividualRankingDetails = ({ uuid, onSuccess, onError }: Input) => {
  const getIndividualRankingDetails = async () => {
    const res = await axiosClient.get<GetIndividualRankingDetailsResponse>(
      GET_GSC_INDIVIDUAL_RANKING_URL(uuid)
    );
    return res.data;
  };
  return useCustomQuery([GET_GSC_INDIVIDUAL_RANKING_KEY], getIndividualRankingDetails, {
    onSuccess,
    onError,
  });
};
